<template>
    <div class="profile-wrapper__profile-main-content">
        <LazyMicroConsultingSection v-if="sectionVisibility[SectionsVisibilityType.MICRO_CONSULTING]" />
        <LazyProfileRelations v-if="relations" />
        <LazySuggestedForYouSection
            v-if="sectionVisibility[SectionsVisibilityType.SUGGESTED_FOR_YOU]"
            v-show="!showTaskList && showSuggestionsSection"
        />
        <LazyTaskListSection v-if="sectionVisibility[SectionsVisibilityType.TASK_LIST]" v-show="showTaskList" />
        <TranslationSection v-if="isFeatureAvailable" />
        <LazyAboutSectionEdit v-if="isEditionEnabled" />
        <AboutSectionReadOnly v-else />
        <LazyPortfolioSection v-if="sectionVisibility[SectionsVisibilityType.PORTFOLIO_REVAMP] && portfolioRevampEnabled" />
        <ExperiencesSection v-if="sectionVisibility[SectionsVisibilityType.EXPERIENCES]" />
        <PortfolioSectionOld v-if="sectionVisibility[SectionsVisibilityType.PORTFOLIO] && !portfolioRevampEnabled" />
        <AppraisalSection v-if="sectionVisibility[SectionsVisibilityType.APPRAISALS]" />
        <RecommendationsSection v-if="sectionVisibility[SectionsVisibilityType.RECOMMENDATIONS]" />
        <SimilarProfiles v-if="sectionVisibility[SectionsVisibilityType.SIMILAR_PROFILES]" />
        <EducationsSection v-if="sectionVisibility[SectionsVisibilityType.EDUCATIONS]" />
        <CertificationsSection v-if="sectionVisibility[SectionsVisibilityType.CERTIFICATIONS]" />
        <SkillSetSection />
        <ReputationWidgetSection v-if="sectionVisibility[SectionsVisibilityType.EXTERNAL_REPUTATION]" />
        <Categories />
        <LazyProfileProductTourSection v-if="sectionVisibility[SectionsVisibilityType.PROFILE_PRODUCT_TOUR]" />
    </div>
</template>

<script lang="ts" setup>
    import {computed} from 'vue';
    import {storeToRefs} from 'pinia';
    import {
        LazyAboutSectionEdit,
        LazyMicroConsultingSection,
        LazyPortfolioSection,
        LazyProfileProductTourSection,
        LazyProfileRelations,
        LazySuggestedForYouSection,
        LazyTaskListSection,
    } from '#components';
    import {useProfilePageViewMode} from '#imports';
    import {useFeatureFlag} from '@malt/feature-flags';
    import PortfolioSectionOld from '~/components/main/PortfolioSectionOld.vue';
    import SkillSetSection from '~/components/main/SkillSetSection.vue';
    import TranslationSection from '~/components/main/TranslationSection.vue';
    import {useProfileSuggestionsVisibility} from '~/composables/useProfileSuggestionsVisibility';
    import AboutSectionReadOnly from '~/features/about/ui/AboutSectionReadOnly.vue';
    import AppraisalSection from '~/features/appraisals/ui/AppraisalSection.vue';
    import Categories from '~/features/categories/Categories.vue';
    import CertificationsSection from '~/features/certifications/ui/CertificationsSection.vue';
    import EducationsSection from '~/features/education/ui/EducationsSection.vue';
    import ExperiencesSection from '~/features/experience/ui/ExperiencesSection.vue';
    import RecommendationsSection from '~/features/recommendations/RecommendationsSection.vue';
    import ReputationWidgetSection from '~/features/reputation-widgets/ReputationWidgetSection.vue';
    import SimilarProfiles from '~/features/similar-profiles/ui/SimilarProfiles.vue';
    import {useProfileStore} from '~/store/profileStore';
    import {useSectionsVisibilityStore} from '~/store/sectionsVisibility';
    import {useAsyncTranslationStore} from '~/store/translation/asyncTranslationStore';
    import {SectionsVisibilityType} from '~/types/domain/SectionsVisibility';

    const {profile, relations} = storeToRefs(useProfileStore());
    const {isFeatureAvailable} = storeToRefs(useAsyncTranslationStore());
    const isPortfolioRevampV1Enabled = useFeatureFlag('portfolio-revamp-v1');
    const isWorkshopAiNantesPortfolioRevampEnabled = useFeatureFlag('workshop-ai-nantes-portfolio-revamp');
    const {sectionVisibility} = storeToRefs(useSectionsVisibilityStore());
    const {showTaskList, showSuggestionsSection} = useProfileSuggestionsVisibility();
    const {isEditionEnabled} = useProfilePageViewMode();
    const portfolioRevampEnabled = computed(
        () => isPortfolioRevampV1Enabled.value || (isWorkshopAiNantesPortfolioRevampEnabled.value && isEditionEnabled.value),
    );
</script>
